import { useEffect } from "react";
import get from "lodash/get";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { selectMulesoftSwaggerData, selectSelectedIntegration } from "./index";
import { EmptyLayout } from "../../components/molecules";
import { hashTagIcon } from "../../assets/icons";
import { selectUser } from "../UserProfile";
import { actions as breadCrumbActions } from "../../components/organisms/BreadCrumb/breadCrumb.reducers";
import Spinner, { SPINNER_NAMES } from "../../components/organisms/Spinner";

const { setSelectedTab } = breadCrumbActions;
const { FETCH_MULESOFT_SWAGGER_DATA } = SPINNER_NAMES;

const MulesoftApiDocs = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUser);
  const swaggerData = useSelector(selectMulesoftSwaggerData);
  const selectedTab = useSelector(selectSelectedIntegration);

  const isAnyDeployedEndpointExists = !isEmpty(get(swaggerData, "paths"));

  useEffect(() => {
    if (currentUser) {
      dispatch(setSelectedTab(selectedTab));
    }
  }, [currentUser, dispatch, selectedTab]);

  return (
    <div className="content justify-between flex flex-col flex-1">
      <Spinner name={FETCH_MULESOFT_SWAGGER_DATA}>
        {  
          <div className="content scrollbar overflow-auto p-6 flex-1">
            <Helmet>
              <title>ApiDocs | TavaJS</title>
            </Helmet>
            <div className="flex-col xs:flex-row flex mb-4 gap-4" />
            {isAnyDeployedEndpointExists ? (
              <div className="bg-gray-100 p-1">
                <SwaggerUI spec={swaggerData} />
              </div>
            ) : (
              <div className="content overflow-auto p-6 flex-1">
                <EmptyLayout
                  title="Deploy Backend app to see the API docs"
                  subTitle="Swagger Data "
                  shouldShowButton={false}
                  image={hashTagIcon}
                />
              </div>
            )}
          </div>
        }
      </Spinner>
    </div>
  );
};

export default MulesoftApiDocs;
